


import React from 'react';
import PropTypes from 'prop-types';
// import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Typography, } from '@material-ui/core';
import { SectionHeader } from 'components/molecules';
import { CardBase } from 'components/organisms';
import { Image } from 'components/atoms';

import Twisthumanpop from 'components/Popups/Twist/Twisthumanpop'
import Sitesat from 'components/Popups/Twist/Sitesat'
import Dnapop from 'components/Popups/Twist/Dnapop'
import Oligopop from 'components/Popups/Twist/Oligopop'
import Colonalpop from 'components/Popups/Twist/Colonalpop'
// import Meseries from 'Components/Popups/Covaris/Meseries'
// import Mseries from 'Components/Popups/Covaris/Mseries'
// import Ultrasonic from 'Components/Popups/Covaris/Ultrasonic'






const useStyles = makeStyles(theme => ({
  cardBase: {
    '&:hover': {
      background: "#7DEDFF",
      '& .card-icon, & .card-title': {
        color: 'white',
      },
    },
  },
  icon: {
    fontSize: 60,
    color: theme.palette.primary.main,
    [theme.breakpoints.up('sm')]: {
      fontSize: 80,
    },
  },
  title: {
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(6),
    },
  },
}));

const Twist = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
         <CardBase >

<Image src="https://ik.imagekit.io/j6phbjneuop/New_Folder/Principal_Partner_Logos/Twist_Biosciences_Logo_Ec5N3fClY.png?updatedAt=1626937057993" />

</CardBase>
<br/>



      <SectionHeader
        title="Featured products"
        subtitle="Twist Biosciences
        "
        data-aos="fade-up"
      />

      <Grid container spacing={isMd ? 4 : 2}>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/Twist/human_WHQAxN7In.png" />


            </div>
            <Typography variant="h5" component="span" className={classes.fontWeight900}>
              <h3 align='center'>Human core Exome kit</h3>&nbsp;
              {/* <Typography  variant="inherit" color="primary">system</Typography> */}
            </Typography>


            <br />
            <br />
            <br/>

            <Twisthumanpop />


          </CardBase>
        </Grid>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/Twist/data_f5vl_ugM5.png" />
            </div>
            <Typography variant="h5" component="span" className={classes.fontWeight900}>
              <h3 align='center'>Dna Data Storage </h3>&nbsp;
              {/* <Typography  variant="inherit" color="primary">system</Typography> */}
            </Typography>


            <br />
            <br />


   <Dnapop/>


          </CardBase>
        </Grid>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/Twist/ss_phuovtjy3.png" />
            </div>
            <Typography variant="h5" component="span" className={classes.fontWeight900}>
              <h3> Site saturation </h3>&nbsp;
              <Typography align='center' variant="inherit" color="primary"></Typography>
            </Typography>

            <br />
            <br />
            <br />
            <br />
        

            <Sitesat/>



          </CardBase>
        </Grid>
      </Grid>
      <Grid container spacing={isMd ? 4 : 2}>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/Twist/oligo_0wK9csqwN.png" />


            </div>
            <Typography variant="h5" component="span" className={classes.fontWeight900}>
              <h3 align= 'center'>Oligo Pools Crisper</h3>&nbsp;
              <Typography variant="inherit" color="primary"></Typography>
            </Typography>


            <br />
            

        
            <Oligopop/>

          </CardBase>
        </Grid>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/Twist/colonal_bSQupbxq9.png?updatedAt=1627464021060" />
            </div>
            <Typography variant="h5" component="span" className={classes.fontWeight900}>
              <h3>Colonel genes </h3>&nbsp;
              <Typography variant="inherit" color="primary"> </Typography>
            </Typography>


<br/>
            <br />
            <br />



            <Colonalpop/>

          </CardBase>
        </Grid>
        <Grid item xs={12} sm={4} data-aos="fade-up">

        </Grid>
      </Grid>
      <Grid container spacing={isMd ? 4 : 2}>
        <Grid item xs={12} sm={4} data-aos="fade-up">

        </Grid>


      </Grid>
    </div>
  );
};

Twist.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Twist;
